import React from 'react';

export function formatNumber(n) {
  if (n == null || isNaN(n)) return '--';
  const abs = Math.abs(n);
  if (abs >= 1_000_000_000) return (n / 1_000_000_000).toFixed(1) + 'B';
  if (abs >= 1_000_000) return (n / 1_000_000).toFixed(1) + 'M';
  if (abs >= 1_000) return (n / 1_000).toFixed(1) + 'K';
  return String(n);
}

export const T = {
  bg: 'var(--bg)',
  panel: 'var(--glass)',
  panelHover: 'var(--glass-strong)',
  border: 'var(--glass-border)',
  borderGlow: 'rgba(162,70,255,0.15)',
  text: 'var(--text-2)',
  textDim: 'var(--text-3)',
  textBright: 'var(--text-1)',
  pink: '#FF2E93',
  purple: '#A346FF',
  success: '#10B981',
  warning: '#F59E0B',
  danger: '#EF4444',
};

export const panelStyle = {
  background: 'var(--glass)',
  border: '1px solid var(--glass-border)',
  borderRadius: 'var(--radius-md)',
  backdropFilter: 'blur(12px)',
};

export function GradientTitle({ text }) {
  return (
    <h3 className="text-[10px] font-semibold uppercase tracking-[0.15em]"
      style={{ background: `linear-gradient(90deg, ${T.pink}, ${T.purple})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', marginBottom: 8, paddingLeft: 4, paddingRight: 4 }}>
      {text}
    </h3>
  );
}

export function SparkLine({ data, maxData = 20, height = 30, color1 = T.pink, color2 = T.purple }) {
  if (!data || data.length < 2) return <div className="flex items-center justify-center text-[9px]" style={{ height, color: T.textDim }}>--</div>;
  const max = Math.max(...data, 1);
  const points = data.slice(-maxData).map((v, i) => `${(i / Math.min(data.length - 1, maxData - 1)) * 100},${height - (v / max) * height}`).join(' ');
  return (
    <svg width="100%" height={height} preserveAspectRatio="none" className="opacity-80">
      <defs>
        <linearGradient id="sparkGrad" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor={color1} />
          <stop offset="100%" stopColor={color2} />
        </linearGradient>
      </defs>
      <polyline fill="none" stroke="url(#sparkGrad)" strokeWidth="1.2" points={points}
        style={{ filter: `drop-shadow(0 0 3px ${color1}40)` }} />
    </svg>
  );
}

export function MiniBar({ value, max = 100, height = 4 }) {
  const pct = Math.min((value / max) * 100, 100);
  const color = pct > 90 ? T.danger : pct > 70 ? T.warning : `url(#miniBarGrad)`;
  return (
    <svg width="100%" height={height} className="overflow-hidden">
      <defs>
        <linearGradient id="miniBarGrad" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor={T.pink} />
          <stop offset="100%" stopColor={T.purple} />
        </linearGradient>
      </defs>
      <rect width="100%" height={height} rx="2" fill="rgba(255,255,255,0.06)" />
      <rect width={`${pct}%`} height={height} rx="2" fill={color}
        style={{ filter: `drop-shadow(0 0 4px ${pct > 70 ? '#ef4444' : pct > 50 ? '#f59e0b' : T.purple}60)` }} />
    </svg>
  );
}

export function StatusDot({ status }) {
  const color = status === 'running' || status === 'healthy' ? T.success : status === 'warning' ? T.warning : status === 'critical' || status === 'high' ? T.danger : T.textDim;
  return <span className="w-1.5 h-1.5 flex-shrink-0" style={{ background: color, boxShadow: `0 0 6px ${color}`, borderRadius: '50%' }} />;
}
